<div class="dialog-container">
  <h2 mat-dialog-title>Browse Sounds</h2>
  
  <mat-dialog-content>
    <p class="dialog-description">
      To play a sound in your script, put the name of the sound onto a new line.<br>
      Click on a sound to preview it and copy its name to your clipboard.
    </p>
    
    <div class="sounds-section">
      @if (sounds.length === 0) {
        <p class="no-sounds">No sounds available.</p>
      } @else {
        <mat-list class="sounds-list">
          @for (sound of sounds; track sound.id) {
            <mat-list-item 
              class="sound-item"
              (click)="onSoundClick(sound)"
              [class.playing]="isPlaying(sound)">
              <mat-icon matListItemIcon class="sound-icon">
                @if (isLoading(sound)) {
                  hourglass_empty
                } @else if (isPlaying(sound)) {
                  volume_up
                } @else {
                  music_note
                }
              </mat-icon>
              <div matListItemTitle class="sound-name">{{ sound.name }}</div>
              <div matListItemMeta>
                <button 
                  mat-icon-button 
                  (click)="onSoundClick(sound); $event.stopPropagation()"
                  [disabled]="isLoading(sound)"
                  class="play-button">
                  <mat-icon>
                    @if (isLoading(sound)) {
                      hourglass_empty
                    } @else {
                      play_arrow
                    }
                  </mat-icon>
                </button>
              </div>
            </mat-list-item>
          }
        </mat-list>
      }
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="onCancel()">Close</button>
  </mat-dialog-actions>
</div>
